<template>
	<div class="login-container">
		<v-container fluid class="login-component">
			<v-row>
				<img class="maxxd-logo" src="@/assets/MAXXD-Logo-Primary-Flame-RGB.svg" alt="MAXX-D" />
			</v-row>
			<v-row>
				<v-col cols="12">
					<h1 class="login-title text-h4">LOG IN</h1>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12">
					<v-text-field
						class="form-input"
						label="Login"
						filled
						dense
						hide-details="auto"
						v-model="loginDetails.username"
					></v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12">
					<v-text-field
						class="form-input"
						label="Password"
						type="password"
						filled
						dense
						hide-details="auto"
						v-model="loginDetails.password"
						@keyup.enter="login()"
					></v-text-field>
				</v-col>
			</v-row>
			<v-row v-if="loadingResults">
				<v-col cols="12" class="login-button-container">
					<v-progress-circular indeterminate color="white" style="z-index: 99999"></v-progress-circular>
				</v-col>
			</v-row>
			<v-row v-show="showErrorMessage">
				<v-col cols="12" class="login-button-container">
					<div
						v-if="showErrorMessage"
						role="alert"
						aria-live="polite"
						aria-atomic="true"
						class="alert alert-danger"
					>
						{{ errorMessage }}
					</div>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" class="login-button-container">
					<v-btn v-on:click="login" color="error"> <v-icon left> mdi-key </v-icon>Log in</v-btn>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
export default {
	name: "Login",
	props: {
		title: {
			type: String,
			default: "LOGIN",
		},
	},
	data() {
		return {
			loginDetails: {
				username: "",
				password: "",
			},
			forgotPassword: false,
			formError: false,
			loadingResults: false,
			showErrorMessage: false,
			errorMessage: "",
		};
	},
	methods: {
		login() {
			let self = this;
			let validForm = this.validate();
			if (validForm) {
				this.loadingResults = true;
				this.$store
					.dispatch("login", this.loginDetails)
					.then(() => {
						this.loadingResults = false;
						this.navigate();
					})
					.catch((error) => {
						this.loadingResults = false;

						if (error.response.data.error) {
							this.errorMessage = error.response.data.error;
							this.showErrorMessage = true;

							setTimeout(function () {
								self.showErrorMessage = false;
								self.errorMessage = false;
							}, 10000);
						}

						if (error.response.status == 401) {
							this.formError = true;
						} else {
							console.log(error.response);
						}
					});
			}
		},
		validate() {
			let self = this;
			self.showErrorMessage = false;
			self.errorMessage = false;

			if (!self.loginDetails.username) {
				this.errorMessage = "Please provide a login.";
				self.showErrorMessage = true;

				setTimeout(function () {
					self.showErrorMessage = false;
					self.errorMessage = false;
				}, 10000);

				return false;
			}

			if (!self.loginDetails.password) {
				this.errorMessage = "Please provide a password.";
				self.showErrorMessage = true;

				setTimeout(function () {
					self.showErrorMessage = false;
					self.errorMessage = false;
				}, 10000);

				return false;
			}

			return true;
		},
		navigate() {
			var to = this.$store.getters.redirectUri ? this.$store.getters.redirectUri : "/home";
			this.$router.push(to);
		},
	},
	async created() {
		let res = await this.$store.dispatch("verifySession");
		if (res && res.status === 200) {
			this.navigate();
		}
		this.$store.dispatch("loading", false);
	},
};
</script>

<style lang="scss" scoped>
.login-container {
	height: 100%;
	background-color: #33373a;
	max-width: none;
	display: flex;
	flex-direction: column;
	justify-content: center;

	.login-component {
		width: 40vh;
		.login-title {
			color: $color-white;
		}

		.form-input {
			background-color: $color-white;
		}

		.login-button-container {
			text-align: center;
		}

		.maxxd-logo {
			display: block;
			width: 35rem;
			height: auto;
			margin: auto;
		}
	}
}

.alert {
	position: relative;
	padding: 1rem 1rem;
	margin-bottom: 1rem;
	border: 1px solid transparent;
	border-radius: 0.25rem;
}

.alert-danger {
	color: #842029;
	background-color: #f8d7da;
	border-color: #f5c2c7;
}
</style>
